import React, { useEffect, useState } from "react";
import t from "../../../helpers/t";
import ReservationsSidebar from "../components/ReservationsSidebar";
import { locationActions, ordersActions, reservationsActions, useSelector } from "inbooma-api";
import { Biscuit, getAllUrlParams, Notification } from "../../../../utils";
import InboomaSubmenu from "../../../components/InboomaSubmenu";
import SortNav from "../../../components/SortNav";
import NextPageBtn from "../../../components/NextPageBtn";
import ReservationsList from "./ReservationsList";
import moment from "moment";
import { $, _ } from "../../../../../vendor";
import { getContentModifications } from "../../../../App";
import Loader from "../../../components/Loader";
import { isViewVisible } from "../../../../utils/ViewSettings";
import ChangeLogDialog from "../../../components/ChangeLogDialog";
import Paginator from "../../../components/paginator";
import { in_array } from "../../../../utils/Helper";
import OrderForm from "./OrderForm/OrderForm";

const ReservationsView = (props) => {
  const useWebsocket = false;
  const currentUrl = new URL(window.location.href);
  const searchParams = currentUrl.searchParams;
  const allUrlParams = getAllUrlParams(window.location.href);
  const allUrlParamsClone = { ...allUrlParams };
  const { dispatch, params, states } = props;
  allUrlParams?.begin_location_name !== undefined && delete allUrlParams.begin_location_name;
  allUrlParams?.end_location_name !== undefined && delete allUrlParams.end_location_name;
  allUrlParams?.contingent_name !== undefined && delete allUrlParams.contingent_name;
  allUrlParams?.date_from !== undefined && delete allUrlParams.date_from;
  allUrlParams?.date_to !== undefined && delete allUrlParams.date_to;
  allUrlParams?.main_filter !== undefined && delete allUrlParams.main_filter;
  allUrlParams?.sort !== undefined && delete allUrlParams.sort;
  allUrlParams?.direction !== undefined && delete allUrlParams.direction;
  allUrlParams?.type !== undefined && delete allUrlParams.type;
  allUrlParams?.begin_gte !== undefined ? allUrlParams.begin_gte : "";
  allUrlParams?.end_lte !== undefined ? allUrlParams.end_lte : "";
  allUrlParams?.types !== undefined ? allUrlParams.types : "";
  allUrlParams?.checkout !== undefined ? allUrlParams.checkout : false;
  allUrlParams?.rentalTimeExceeded !== undefined && delete allUrlParams.rentalTimeExceeded;
  if (allUrlParams?.initial !== undefined) {
    allUrlParams.begin_gte = moment().format("YYYY-MM-DD") + "%2000:00:00";
    delete allUrlParams.initial;
  }
  allUrlParams?.order_nbr !== undefined ? allUrlParams.order_nbr : "";
  allUrlParams?.returnurl !== undefined ? allUrlParams.returnurl : null;
  allUrlParams?.status !== "undefined" &&
    in_array(allUrlParams?.status, ["all", "allwithoutcancelled"]) &&
    delete allUrlParams.status;
  let language = Biscuit.get("user.lang").replace("-", "_");

  const [initialized, setInitialized] = useState(false);
  const [filter, setFilter] = useState({
    find: "full",
    ...(!in_array(allUrlParams?.status, ["all", "cancelled"]) && { finder: "NotCancelled" }),
    ...allUrlParams,
  });
  const [sort, setSort] = useState({
    sort: allUrlParamsClone?.sort !== undefined ? allUrlParamsClone.sort : "begin",
    direction: allUrlParamsClone?.direction !== undefined ? allUrlParamsClone.direction : "desc",
  });
  const [_key, setKey] = useState(null);
  const paginationLimit = 40;
  const [pagination, setPagination] = useState({
    has_next_page: false,
    current_page: 1,
  });
  const _locations = useSelector((state) => state.locations_data.locations);
  const [locations, setLocations] = useState([]);
  const [checkout, setCheckout] = useState(allUrlParams?.checkout);
  const [returnUrl, setReturnUrl] = useState(allUrlParams?.returnurl);
  const [checkInCheckOut, setCheckInCheckOut] = useState(false);
  const [reservations, setReservations] = useState([]);
  const [reservationsPending, setReservationsPending] = useState(false);
  const [ordersPending, setOrdersPending] = useState(false);
  const _reservations = useSelector((state) => state["reservations"].getReservations);
  const [resetFilter, setResetFilter] = useState(false);
  const _reservationSummary = useSelector((state) => state.reservations.getReservationSummary);
  const [summaryPending, setSummaryPending] = useState(false);
  const [summary, setSummary] = useState([]);
  const [resourceId, setResourceId] = useState(null);
  const [reservationId, setReservationId] = useState(null);
  const [reservationOrderNbr, setReservationOrderNbr] = useState(null);
  const [changelogOpen, setChangelogOpen] = useState(false);
  const [changelog, setChangelog] = useState([]);
  const [locationsPending, setLocationsPending] = useState(false);
  //const _patchReservation = useSelector(state => state.reservations.patchReservations);
  //const _patchOrder = useSelector(state => state.orders.patchOrder);
  const _queryState = {
    timeStamp: 0,
    value: "",
  };

  useEffect(() => {
    if (_locations.success === "") return;

    if (_locations.success === true && _locations.data.length) {
      let ld = [];
      _locations.data.map((l) => {
        ld[l.id] = l;
      });
      setLocations(ld);
    } else if (_locations.success === false) {
      console.log("Failed to request locations!");
    }
    setLocationsPending(false);
  }, [_locations]);

  /* useEffect(() => {
        if (_patchReservation.success === "") {
            return;
        }

        if (_patchReservation.success === true) {

        } else {
            console.log("Failed patching reservation!");
        }
        setReservationsPending(false);
        filterChangedHandle(filter);
    },[_patchReservation]);*/

  /*    useEffect(() => {
        if (_patchOrder.success === "") {
            return;
        }

        if (_patchOrder.success === true) {

        } else {
            console.log("Failed patching order!");
        }
        setOrdersPending(false);
        filterChangedHandle(filter);
    },[_patchOrder]);*/

  useEffect(() => {
    if (reservationsPending === false || _reservations.success === "") {
      return;
    }
    if (_reservations.success === true) {
      if (_reservations.pagination.current_page === 1) {
        if (_reservations.data.length === 0 && Array.isArray(_reservations.data)) {
          setReservations([]);
        } else {
          setReservations(_reservations.data);
        }
      } else {
        setReservations(_reservations.data);
      }
      setPagination({ ..._reservations.pagination });
    } else {
      console.log("Failed fetching reservations!");
    }
    setReservationsPending(false);
    $(window).scrollTop(0);
  }, [_reservations]);

  useEffect(() => {
    if (summaryPending === false || _reservationSummary.success === "") {
      return;
    }
    if (_reservationSummary.success === true) {
      setSummary(_reservationSummary.data);
    } else {
      console.log("Failed fetching reservation summary!");
    }
    if (!useWebsocket) {
      setSummaryPending(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_reservationSummary]);

  useEffect(() => {
    if (reservationsPending || summaryPending) return;
    let clone = {};
    Object.assign(clone, filter);
    if (typeof allUrlParamsClone.main_filter !== "undefined") {
      clone["main_filter"] = allUrlParamsClone.main_filter;
    } else {
      if (typeof allUrlParamsClone.initial !== "undefined") {
        clone["main_filter"] = "upcoming";
      } else {
        clone["main_filter"] = "all";
      }
    }
    if (typeof allUrlParamsClone.status !== "undefined") {
      clone["booking_filter"] = allUrlParamsClone.status;
    } else {
      clone["booking_filter"] = "allwithoutcancelled";
    }
    if (typeof filter.paystate !== "undefined") {
      clone["paystate"] = filter.paystate;
    }
    if (typeof filter.begin_location !== "undefined") {
      clone["begin_location"] = filter.begin_location;
    }
    if (typeof filter.end_location !== "undefined") {
      clone["end_location"] = filter.end_location;
    }
    if (typeof filter.begin_gte !== "undefined" && clone["main_filter"] !== "upcoming") {
      clone["begin_gte"] = filter.begin_gte;
    }
    if (typeof filter.end_lte !== "undefined") {
      clone["end_lte"] = filter.end_lte;
    }
    if (typeof filter.contingent_id !== "undefined") {
      clone["contingent_id"] = filter.contingent_id;
    }
    if (typeof filter.types !== "undefined") {
      clone["types"] = filter.types;
    }
    if (typeof filter.rentaltimeexceeded !== "undefined") {
      clone["rentaltimeexceeded"] = filter.rentaltimeexceeded;
    }
    clone["requestId"] = Biscuit.get("user.id");
    dispatch(
      reservationsActions.getReservationSummary({
        token: Biscuit.get("token"),
        filter: clone,
        parameters: {
          headers: {
            "Accept-Language": language,
            "Content-Language": language,
          },
        },
      }),
    );
    setSummaryPending(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reservations]);

  const loadNextPage = (page) => {
    // if (!pagination.has_next_page) return;

    setReservationsPending(true);

    let requestFilter = { ...filter };
    if (allUrlParams?.item !== undefined) {
      delete requestFilter.begin_gte;
    }
    requestFilter.sort = sort.sort;
    requestFilter.direction = sort.direction;
    requestFilter.limit = paginationLimit;
    requestFilter.page = page;
    if (
      typeof allUrlParams.initial !== "undefined" &&
      typeof requestFilter.begin_gte === "undefined"
    ) {
      requestFilter.begin_gte = moment().format("YYYY-MM-DD 00:00:00");
      requestFilter.sort = "begin";
      requestFilter.direction = "asc";
    }
    if (page > 1) {
      searchParams.set("page", page);
      const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
      history.pushState(null, "", newRelativePathQuery);
    } else {
      searchParams.delete("page");
      const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
      history.pushState(null, "", newRelativePathQuery);
    }
    // fetch next page
    setReservations([]);
    dispatch(reservationsActions.getReservationsResetData());
    dispatch(
      reservationsActions.getReservations({
        token: Biscuit.get("token"),
        suffix: "",
        filter: requestFilter,
        parameters: {
          headers: {
            "Accept-Language": language,
            "Content-Language": language,
          },
        },
      }),
    );
  };

  /*const getOrdersFilterByReservations = (reservations) => {

        if (typeof reservations === 'undefined' || reservations === null || reservations.length == 0) {
            return {
                limit: 100
            }
        }
       let lowest = 9999999999999999;
       let highest = 0;
       for (var i=0;i<reservations.length;i++) {
           if(typeof reservations[i].order === 'undefined' || reservations[i].order === null){continue;}
           if (typeof reservations[i].order.order_nbr === 'undefined' || reservations[i].order.order_nbr === null) {continue;}
           if (Number(reservations[i].order.order_nbr) > highest) {highest = Number(reservations[i].order.order_nbr);}
           if (Number(reservations[i].order.order_nbr) < lowest) {lowest = Number(reservations[i].order.order_nbr);}
       }

        return {
            limit: 999,
            order_nbr_gte: lowest,
            order_nbr_lte: highest
        };
    };*/

  /*const areReservationsSame = (reservations1, reservations2) => {

        // check first / input wallet if empty
        if (reservations1.length === 0 && Array.isArray(reservations1)) {
            reservations1 = {}
        }

        for (var i=0;i<reservations1.length;i++) {
            if(reservations1[i].id != reservations2[i].id) return false;
        }
        return true;
    };*/

  const filterChangedHandle = (filter, sorts = null) => {
    let requestFilter = { ...filter };
    console.log(requestFilter);
    if (sorts === null) {
      sorts = sort;
    } else {
      setSort(sorts);
    }
    requestFilter.sort = sorts.sort;
    requestFilter.direction = sorts.direction;
    if (typeof filter.limit !== "undefined") {
      requestFilter.limit = filter.limit;
      if (typeof requestFilter.page !== "undefined") {
        delete requestFilter.page;
      }
    } else {
      requestFilter.limit = paginationLimit;
      requestFilter.page = 1;
    }
    console.log("allUrlParams", allUrlParams);
    console.log("requestFilter", requestFilter);
    if (
      typeof allUrlParams.initial !== "undefined" &&
      typeof requestFilter.begin_gte === "undefined"
    ) {
      requestFilter.begin_gte = moment().format("YYYY-MM-DD 00:00:00");
      requestFilter.sort = "begin";
      requestFilter.direction = "asc";
    }
    /* if(typeof allUrlParams.begin_gte !== 'undefined' && (typeof allUrlParams.status === 'undefined' || !in_array(allUrlParams.status,['all','allwithoutcancelled']))){
            requestFilter.begin_gte = allUrlParams.begin_gte;
            requestFilter.sort = 'begin';
            requestFilter.direction = 'asc';
        }*/
    setReservations([]);
    dispatch(reservationsActions.getReservationsResetData());
    dispatch(
      reservationsActions.getReservations({
        token: Biscuit.get("token"),
        suffix: "",
        filter: requestFilter,
        parameters: {
          headers: {
            "Accept-Language": language,
            "Content-Language": language,
          },
        },
      }),
    );
    setReservationsPending(true);
    setFilter(filter);
  };

  const onSortChangedHandle = (ev) => {
    const el = ev.currentTarget;
    const sortKey = el.getAttribute("data-inb-val"),
      direction = el.getAttribute("data-inb-direction"),
      isOppositeElement = direction === null && el.classList.contains("is-active"),
      newDirection = direction === "desc" || isOppositeElement ? "asc" : "desc";

    if (sortKey) {
      let requestFilter;
      if (typeof filter.limit !== "undefined") {
        requestFilter = {
          ...filter,
          sort: sortKey,
          direction: direction,
        };
      } else {
        requestFilter = {
          ...filter,
          sort: sortKey,
          direction: direction,
          limit: paginationLimit,
          page: 1,
        };
      }
      if (resourceId !== null) {
        requestFilter = {
          ...requestFilter,
          resource_id: resourceId,
        };
      }
      if (reservationId !== null) {
        requestFilter = {
          ...requestFilter,
          id: reservationId,
        };
      }
      if (reservationOrderNbr !== null) {
        requestFilter = {
          ...requestFilter,
          order_nbr: reservationOrderNbr,
        };
      }
      if (
        typeof allUrlParams.initial !== "undefined" &&
        typeof requestFilter.begin_gte === "undefined"
      ) {
        requestFilter.begin_gte = moment().format("YYYY-MM-DD 00:00:00");
        requestFilter.sort = "begin";
        requestFilter.direction = "asc";
      }
      setReservations([]);
      dispatch(reservationsActions.getReservationsResetData());
      dispatch(
        reservationsActions.getReservations({
          token: Biscuit.get("token"),
          suffix: "",
          filter: requestFilter,
          parameters: {
            headers: {
              "Accept-Language": language,
              "Content-Language": language,
            },
          },
        }),
      );
      setReservationsPending(true);
      setSort({
        sort: sortKey,
        direction: direction,
      });

      const activeSortTab = $(".is-active");
      _.each(activeSortTab, function (key) {
        key["classList"].remove("is-active");
      });
      el.classList.add("is-active");
      el.setAttribute("data-inb-direction", isOppositeElement ? "desc" : newDirection);
    }
  };

  const searchBarHandler = (ev) => {
    let query;
    if (typeof ev.target !== "undefined") {
      query = ev.target.value.toLowerCase();
    } else {
      query = "";
    }
    searchParams.delete("order_nbr");
    searchParams.delete("item");
    if (query !== "") {
      if (isNaN(Number(query))) {
        showNotification("warning", null, t("query must be number"));
        query = "";
        return;
      }
      searchParams.set("order_nbr", query);
    }
    const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
    history.pushState(null, "", newRelativePathQuery);
    const minLength = 1;
    if (query.length >= minLength) {
      // work user search only for values bigger or equal to the minimum length
      if (allUrlParams?.initial !== undefined) {
        delete allUrlParams?.initial;
      }
      delete allUrlParams?.begin_gte;
      let filterA = {
        sort: "id",
        direction: "desc",
        page: 1,
        find: "full",
        limit: 40,
        ...allUrlParams,
      };

      setResetFilter(true);
      setTimeout(function () {
        let diff = Number(moment().format("x")) - _queryState.timeStamp;

        if (diff > 700 && _queryState.value === query) {
          // no changes after the last 700 ms -> user finished input -> start request
          filterChangedHandle({
            ...filterA,
            order_nbr: query,
          });
        }
      }, 800);
    } else if (filter.order_nbr !== undefined) {
      // reset filter when query was active
      let clone = { ...filter };
      delete clone.order_nbr;
      filterChangedHandle(clone);
    } else {
      filterChangedHandle(filterA);
    }
    _queryState.timeStamp = Number(moment().format("x"));
    _queryState.value = query;
  };

  const initialize = () => {
    const filterDefault = filter;
    if (initialized || reservationsPending || locationsPending) return;
    if (
      allUrlParams?.begin_gte !== undefined ||
      allUrlParams?.end_lt !== undefined ||
      allUrlParams?.begin_day !== undefined ||
      allUrlParams?.end_day !== undefined ||
      allUrlParams?.end_gte !== undefined ||
      allUrlParams?.end_lte !== undefined
    ) {
      delete filterDefault.begin_gte;
    }

    let requestFilter = { ...filterDefault };
    requestFilter = { ...requestFilter, page: pagination.current_page };
    requestFilter = { ...requestFilter, limit: paginationLimit };
    requestFilter = { ...requestFilter, sort: sort.sort };
    requestFilter = { ...requestFilter, direction: sort.direction };
    requestFilter = { ...requestFilter, ...allUrlParams };
    if (allUrlParams.begin_gte !== undefined) {
      requestFilter = {
        ...requestFilter,
        sort: "begin",
        direction: "asc",
      };
    } else if (allUrlParams.end_lt !== undefined) {
      requestFilter = {
        ...requestFilter,
        sort: "end",
        direction: "desc",
      };
    } else if (allUrlParams.begin_day) {
      let temp = allUrlParams.begin_day.split("%");
      allUrlParams.begin_day = temp[0];
      requestFilter = {
        ...requestFilter,
        sort: "begin",
        direction: "asc",
      };
    } else if (allUrlParams.end_day !== undefined) {
      let temp = allUrlParams.end_day.split("%");
      allUrlParams.end_day = temp[0];
      requestFilter = {
        ...requestFilter,
        sort: "end",
        direction: "desc",
      };
    } else if (allUrlParams.end_gte !== undefined) {
      requestFilter = {
        ...requestFilter,
        sort: "end",
        direction: "asc",
      };
    } else if (allUrlParams.end_lte !== undefined) {
      requestFilter = {
        ...requestFilter,
        sort: "begin",
        direction: "desc",
      };
    }
    console.log(params);
    console.log(states);
    if (
      params !== null &&
      typeof params[1] !== "undefined" &&
      (params[0] === "contingent_id" || params[0] === "resource_id" || params[0] === "user_id")
    ) {
      if (params[0] === "resource_id") {
        requestFilter = { ...filter, resource_id: params[1] };
      }
      delete requestFilter.begin_gte;
      delete requestFilter.finder;
      let clone = { ...filter };
      delete clone.begin_gte;
      setFilter(clone);
      setSort({ ...sort, direction: "desc" });
      requestFilter = { ...requestFilter, sort: sort.sort };
      requestFilter = { ...requestFilter, direction: "desc" };
      if (params[0] === "resource_id") {
        setResourceId(params[1]);
      }
    }
    if (params !== null && typeof params[1] !== "undefined" && params[0] === "reservation_id") {
      requestFilter = { ...filter, id: params[1] };
      delete requestFilter.begin_gte;
      delete requestFilter.finder;
      let clone = { ...filter };
      delete clone.begin_gte;
      setFilter(clone);
      setSort({ ...sort, direction: "desc" });
      requestFilter = { ...requestFilter, sort: sort.sort };
      requestFilter = { ...requestFilter, direction: "desc" };
      setReservationId(params[1]);
    }
    if (allUrlParamsClone?.order_nbr !== undefined) {
      requestFilter = { ...filter, order_nbr: allUrlParamsClone?.order_nbr };
      delete requestFilter.begin_gte;
      delete requestFilter.finder;
      let clone = { ...filter };
      delete clone.begin_gte;
      setFilter(clone);
      setSort({ ...sort, direction: "desc" });
      requestFilter = { ...requestFilter, sort: sort.sort };
      requestFilter = { ...requestFilter, direction: "desc" };
      setReservationOrderNbr(allUrlParamsClone?.order_nbr);
    }
    setReservations([]);
    dispatch(reservationsActions.getReservationsResetData());
    dispatch(
      reservationsActions.getReservations({
        token: Biscuit.get("token"),
        suffix: "",
        filter: requestFilter,
        parameters: {
          headers: {
            "Accept-Language": language,
            "Content-Language": language,
          },
        },
      }),
    );
    dispatch(
      locationActions.getLocations({
        token: Biscuit.get("token"),
        filter: {
          limit: 10000,
        },
        parameters: {
          headers: {
            "Accept-Language": language,
          },
        },
      }),
    );
    setLocationsPending(true);
    setInitialized(true);
    setReservationsPending(true);
  };

  initialize();

  const _exchangeLabel = (value) => {
    let cm = getContentModifications();
    if (cm.labels != null) {
      if (cm.labels[value] !== undefined) {
        return cm.labels[value];
      }
    }
    return value;
  };

  const openChangeLog = (ev) => {
    setChangelog(ev);
    setChangelogOpen(true);
  };
  const handleCloseDialog = () => {
    setChangelogOpen(false);
  };

  let sendParams = "";

  if (typeof allUrlParamsClone.order_nbr !== "undefined") {
    sendParams = "&order_nbr=" + allUrlParamsClone.order_nbr;
  } else {
    if (typeof allUrlParamsClone.user_id !== "undefined") {
      sendParams =
        "&user_id=" + allUrlParamsClone.user_id + "&fullname=" + allUrlParamsClone.fullname;
    }
    if (typeof allUrlParamsClone.paystate !== "undefined") {
      sendParams +=
        "&paystate=" +
        allUrlParamsClone.paystate +
        "&paystate_name=" +
        allUrlParamsClone.paystate_name;
    }
  }
  const submenuItems = [
    {
      name: t("reservations", null, "capital"),
      link: "reservations/reservationsList?type=bookings&initial=true",
      data_inb_val: t("reservations", null, "capital"),
      icon: "fi fi-list-thumbnails",
      isActive: true,
      isAccessible: isViewVisible("reservationsList", "reservations"),
    },
    {
      name: t("orders", null, "capital"),
      link: "reservations/orders?type=orders" + sendParams,
      data_inb_val: t("orders", null, "capital"),
      icon: "fi fi-list",
      isActive: false,
      isAccessible: isViewVisible("orders", "reservations"),
    },
    {
      name: t("calendar", null, "capital"),
      link: "reservations/calendar",
      data_inb_val: t("calendar", null, "capital"),
      icon: "fi fi-calendar",
      isActive: false,
      isAccessible: isViewVisible("calendar", "reservations"),
    },
  ];
  const isHiddenElement = (id) => {
    let cm = getContentModifications();
    if (cm.hidden_elements != null && cm.hidden_elements.length > 0) {
      for (let i = 0; i < cm.hidden_elements.length; i++) {
        if (cm.hidden_elements[i] === id) return true;
      }
    }
    return false;
  };
  const onStatusChangedHandler = (e, item) => {
    if (typeof item.order_id !== "undefined") {
      /*  dispatch(reservationsActions.patchReservations({
                token: Biscuit.get('token'),
                reservation_id: item.id,
                data: {
                    status: e.target.value
                },
                parameters: {
                    headers: {
                        "Accept-Language": language,
                        "Content-Language": language
                    }
                }
            }));
            setReservationsPending(true);*/
    } else {
      /* dispatch(ordersActions.patchOrder({
                 token: Biscuit.get('token'),
                 order_id: item.id,
                 data: {
                     status: e.target.value
                 },
                 parameters: {
                     headers: {
                         "Accept-Language": language,
                         "Content-Language": language
                     }
                 }
             }));
             setOrdersPending(true);
         }*/
    }
  };
  let tabs = [
    {
      name: t("date", null, "capital"),
      smallWidth: 3,
      mediumWidth: 8,
      extraClasses: "large-2",
      title: t("sort_by_${a}", { a: t("date") }, "capital"),
      canSort: true,
      preselected: true,
      sort: {
        direction: sort.direction,
        data_inb_val: sort.sort,
      },
    },
    {
      name: t("order_nbr", null, "capital"),
      smallWidth: 3,
      mediumWidth: 1,
      extraClasses: "large-1",
      title: t("order_nbr", null, "capital"),
      canSort: false,
    },
    {
      name: t("description", null, "capital"),
      mediumWidth: 2,
      smallWidth: 3,
      extraClasses: "large-2",
      title: t("description", null, "capital"),
      canSort: false,
    },
    {
      name: t(_exchangeLabel("location_of_checkin"), null, "capital"),
      smallWidth: 3,
      mediumWidth: 2,
      extraClasses: "large-2",
      title: t(_exchangeLabel("location_of_checkin"), null, "capital"),
      canSort: false,
    },
    isHiddenElement("inb-res-sort-tabs-checkout-loc") === true
      ? {
          name: "",
          smallWidth: 3,
          mediumWidth: 2,
          extraClasses: "large-2",
          title: "",
          canSort: false,
        }
      : {
          name: t(_exchangeLabel("location_of_checkout"), null, "capital"),
          smallWidth: 3,
          mediumWidth: 2,
          extraClasses: "large-2",
          title: t("end_location", null, "capital"),
          canSort: false,
        },
    {
      name: t("status", null, "capital"),
      smallWidth: 3,
      mediumWidth: 2,
      extraClasses: "inb-status-select large-3",
      title: t("status", null, "capital"),
      canSort: false,
    },
  ];
  const showNotification = (msgType, itemId, errorMsg = "", type = "order") => {
    if (msgType === "success") {
      new Notification({
        message: t("saved_${a}", { a: t(type) }, "capital") + " #" + itemId,
        duration: 5000,
        type: "success",
        closeable: true,
        icon: "fi fi-check",
      });
    } else if (msgType === "warning") {
      new Notification({
        message: errorMsg,
        duration: 5000,
        type: "warning",
        closeable: true,
        icon: "fi fi-x",
      });
    }
  };
  return (
    <>
      {initialized && !checkout && !checkInCheckOut && (
        <ReservationsSidebar
          dispatch={dispatch}
          heading={t("reservations", null, "capital")}
          filterChangedHandle={filterChangedHandle}
          filter={filter}
          resetFilter={resetFilter}
          setResetFilter={setResetFilter}
          sort={sort}
          setSort={setSort}
          setResourceId={setResourceId}
          setReservationId={setReservationId}
          summary={summary}
          summaryPending={summaryPending}
          setSummaryPendíng={setSummaryPending}
        />
      )}
      <div id="inb-c-main" className="columns reservation">
        <InboomaSubmenu
          tabs={submenuItems}
          searchbar={true}
          extraClasses={"sticky-top"}
          searchbarPlaceholder={t("order_nbr")}
          searchbarValue={
            allUrlParamsClone?.order_nbr !== undefined ? allUrlParamsClone.order_nbr : ""
          }
          searchbarHandler={searchBarHandler}
          smallOnlyTitle={t("reservations", null, "capital")}
          pagination={pagination}
          itemsCountPerPage={paginationLimit}
          pageRangeDisplayed={5}
          onChange={loadNextPage}
          initialized={initialized}
          itemLength={reservations.length}
        />

        {!checkout && !checkInCheckOut && (
          <>
            <SortNav
              tabs={tabs}
              extraClasses={"sticky-top-sortbar"}
              listStyle="tight"
              handler={onSortChangedHandle}
            />
          </>
        )}
        {/* {initialized && reservations.length > 0 && !checkout && !checkInCheckOut && typeof pagination !== 'undefined' &&
                    <Paginator
                        pagination={pagination}
                        itemsCountPerPage={paginationLimit}
                        pageRangeDisplayed={5}
                        onChange={loadNextPage}
                        upper={true}
                    />} */}
        <div className="off-canvas-wrapper">
          {initialized && reservations.length > 0 && !locationsPending && !ordersPending && (
            <ReservationsList
              reservations={reservations}
              locations={locations}
              // onStatusChangedHandler={onStatusChangedHandler}
              dispatch={dispatch}
              checkout={checkout}
              returnUrl={returnUrl}
              setCheckout={setCheckout}
              _exchangeLabel={_exchangeLabel}
              filterChangedHandle={filterChangedHandle}
              filter={filter}
              setFilter={setFilter}
              sort={sort}
              setSort={setSort}
              setCheckInCheckOut={setCheckInCheckOut}
              checkInCheckOut={checkInCheckOut}
              _key={_key}
              setKey={setKey}
              params={params}
              openChangeLog={openChangeLog}
              showNotification={showNotification}
            />
          )}
          {initialized && (states.orderAdd || (states.orderEdit && states.orderId)) && (
            <OrderForm
              dispatch={dispatch}
              params={states}
              returnUrl={new URL(window.location.href)}
              //dispatch, helpMessage, showNotification, setAddHelpMessage, filter, filterChangedHandle, requestPath, currentUrl, language
            />
          )}
          {initialized &&
            (reservations.length < 1 || typeof reservations.length === "undefined") &&
            !checkout &&
            !checkInCheckOut &&
            !reservationsPending && (
              <>
                <div
                  id="inb-app-collection-empty"
                  className="inb-announcement"
                  style={{ minHeight: "1150px" }}
                >
                  <div className="inb-image-box">
                    <img alt="No Data" src={"assets/img/no_data.svg"} />
                  </div>
                  <h3>{t("app_msg_collection_empty")}</h3>
                  <p>{t("app_msg_collection_empty_body")}</p>
                </div>
              </>
            )}
          {/* {initialized && reservations.length > 0 && !checkout && !checkInCheckOut && typeof pagination !== 'undefined' &&
                        <Paginator
                            pagination={pagination}
                            itemsCountPerPage={paginationLimit}
                            pageRangeDisplayed={5}
                            onChange={loadNextPage}
                            upper={false}
                        />} */}
          {initialized && changelogOpen && !checkout && !checkInCheckOut && (
            <ChangeLogDialog
              changeLogs={changelog}
              handleCloseDialog={handleCloseDialog}
              toggleChangeLogs={true}
            />
          )}
          {reservationsPending && !checkout && !checkInCheckOut && (
            <Loader mediumWidth={2} smallWidth={4} subLoaders={5} />
          )}
        </div>
      </div>
    </>
  );
};

export default ReservationsView;
